/**
 * Date formatting for the Instagram surfaces. Its own module rather than a named export
 * alongside the components in InstagramConnectionFacts.tsx — a file that exports both
 * components and plain functions breaks React Fast Refresh.
 */
export const formatInstagramDate = (iso: string | null) =>
  iso ? new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '—';
